export default __webpack_public_path__ + "fonts/roboto-slab-400.woff";